<template>
  <div class="page-view">
    <div class="page-view__content" style="flex: 1;"> <!-- TODO: Fix styles -->
      <slot/>
    </div>
    <div class="page-view__footer">
      <in-viewport>
        <footer-navigation-container v-if="!hideNavigation"/>
      </in-viewport>
      <footer-component/>
    </div>
  </div>
</template>

<script>
import FooterNavigationContainer from '@/containers/FooterNavigation'
import FooterComponent from '@/components/Footer'

export default {
  components: {
    FooterNavigationContainer,
    FooterComponent
  },
  props: {
    hideNavigation: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .page-view {
    $content: &__content;
    @include sticky-footer($content);
    min-height: 125vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/PageView.vue